import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/EInvoiceRecipient";

export const Check = (options) => GENERATE_URL(`${PREFIX_URL}/Check`, options);

export default {
  Check,
};
